import React, { useState } from 'react'

import { Tooltip } from 'react-tippy'

export default function WrongEmailMessage(props) {
  const { errorMessage } = props

  const [tooltipShown, setTooltipShown] = useState(false)

  return (
    <Tooltip
      html={
        <span>
          If you do not have a University Steppingblocks account, you can sign up{' '}
          <a href="https://app.steppingblocks.com" target="_blank" rel="noopener noreferrer">
            here
          </a>
          .
        </span>
      }
      arrow
      sticky
      interactive={true}
      open={tooltipShown}
      trigger="manual"
      hideOnClick={true}
      hideDelay={2000}
      onRequestClose={() => {
        setTooltipShown(false)
      }}
    >
      <span>
        {errorMessage}{' '}
        <i
          className="info-button fal fa-info-circle tag-info-button"
          onClick={() => setTooltipShown(true)}
        />
      </span>
    </Tooltip>
  )
}



// WEBPACK FOOTER //
// ./src/components/ui/forms/wrongEmailMessage.js